// extracted by mini-css-extract-plugin
export default {"antSliderHandle":"antSliderHandle--JOZx7","sliderTrack":"sliderTrack--gVh_a","sliderRoot":"sliderRoot--xKkOa","rail":"rail--HmXQ1"};